<template>
  <div class="introduce-container">
    <div class="desc_wrap">
      <span class="media_font_size_50"
        >筚路蓝缕七十载，扬帆奋楫开新局。1953年，中国汽车工业破土萌芽，中国人“造自己的汽 车”的愿望从梦想照进现实。七十载漫漫长路，中国汽车人沐风栉雨、披星戴月，建立起中国汽车 产业，取得了从零到壹的突破，实现了由小到大的发展，见证了中国汽车市场从不足500万的 年产销量，到达成1000万辆的梦想，再到2000万辆的飞跃，开启了汽车大国向汽车强国的新时代高质量发展之路。</span>
      <span class="media_font_size_50"
        >当前世界之变、时代之变、历史之变正以前所未有的方式展开，中国汽车产业正处于国际化 加快高质量发展的关键时期。以“新科技”为核心的新能源汽车，作为中国汽车产业实现弯道超 车、从汽车大国迈向汽车强国的重要路径，已然成为业界共识。我国坚持纯电驱动战略取向，新 能源汽车产业发展取得了巨大成就，2015年以来产销量连续9年居世界首位。中国汽车在新能 源方面的先发优势正在从销量优势向技术优势转变，并逐渐引领世界新能源汽车产业变革新方向。</span>
      <span class="media_font_size_50"
        >广州车展自2003年创办以来，始终秉承“新科技、新生活”的主题理念，以为汽车行业打造 高品质、国际化、综合性的展览体验平台为宗旨，与行业精英携手共进，砥砺前行，共同见证了中国汽车产业的发展与成长，参与了世界汽车工业的革新与重塑。第二十二届广州国际汽车展览会将于2024年11月15日至24日，在中国进出口商品交易会展馆盛大举办。我们诚邀全球车企共襄盛举，展示前沿新科技，共创美好新生活。</span>
    </div>
    <div class="img_wrap">
      <div v-for="(item, index) in imgList" :key="index">
        <div class="wrap_top">
          <div class="lf_wrap">
            <img :src="item.icon" alt />
            <div class="flex-container">
              <span>{{ item.title }}</span>
              <span>{{ item.en }}</span>
            </div>
          </div>
          <div class="rt_wrap">
            <span>{{ item.desc }}</span>
            <span>{{ item.desc_en }}</span>
          </div>
        </div>
        <img :src="item.imgUrl" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          icon: require("../../../assets/img/introduce/bt_2.png"),
          title: "展会日期：",
          desc: "2024年11月15-24日",
          imgUrl: require("../../../assets/img/introduce/bg_1.jpg"),
          en: "Date:",
          desc_en: "November 15-24, 2024",
        },
        {
          icon: require("../../../assets/img/introduce/bt_1.png"),
          title: "展会地点：",
          desc: "中国进出口商品交易会展馆",
          imgUrl: require("../../../assets/img/introduce/bg_2.jpg"),
          en: " Venue:",
          desc_en: "China Import and Export Fair Complex（Canton Fair Complex）",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.introduce-container {
  width: 100%;
  .desc_wrap {
    display: flex;
    flex-direction: column;
    margin-bottom: 139px;
    > span {
      text-indent: 48px;
      font-size: 24px;
      color: #fff;
      line-height: 50px;
    }
  }
  .img_wrap {
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    > div {
      .wrap_top {
        display: flex;
        align-items: center;
        margin-bottom: 31px;
        .lf_wrap {
          color: #009cff;
          margin-right: 10px;
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          > span {
            font-size: 24px;
          }
          > div {
            > span {
              line-height: 20px;
            }
          }
        }
        .rt_wrap {
          display: flex;
          flex-direction: column;
          > span {
            font-size: 12px;
            color: #fff;
            line-height: 20px;
          }
        }
      }
      > img {
        width: 585px;
        height: 304px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .introduce-container {
    .desc_wrap {
      > span {
        line-height: 120px;
        text-indent: 96px;
      }
    }
    .img_wrap {
      .wrap_top {
        flex-direction: column;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// introduce.vue?2d7c06ac